// extracted by mini-css-extract-plugin
export default {"markdown":"vdNfYV1Ajy5ZsXm93ZwZ"};